/* D/R r60: brand-selection first step (brand = product metafield custom.brand, same as the T-shirts collection filter; step 1 has no images).
   D/R r47 (A-07 paid-tee warning, A-08 revalidate + cross-tab sync, A-09 persistent reopen, A-11 timeouts/recovery) — based on r46.
   D/R r42 — "YOUR FREE T-SHIRT" modal + cart reminder.
   Source of truth: /cart.js. Never labels anything free unless cart.js shows the free-tee discount on it. */
(function () {
  'use strict';

  /* ---------------- pure logic (unit-tested in node) ---------------- */
  function norm(s) { return String(s || '').toLowerCase().replace(/[\u2013\u2014]/g, '-').replace(/\s+/g, ' ').trim(); }
  function isFreeTeeTitle(title) { return norm(title).indexOf('free tee') !== -1; }

  function lineAllocations(item) {
    var out = [];
    if (Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length) {
      item.line_level_discount_allocations.forEach(function (a) {
        out.push({ title: (a.discount_application && a.discount_application.title) || a.title || '', amount: Number(a.amount) || 0 });
      });
    } else if (Array.isArray(item.discounts)) {
      item.discounts.forEach(function (d) { out.push({ title: d.title || '', amount: Number(d.amount) || 0 }); });
    }
    return out;
  }

  /* cart: parsed /cart.js; eligibleIds / teeIds: Set of product ids (numbers) */
  function computeState(cart, eligibleIds, teeIds) {
    var s = { eligibleUnits: 0, teeUnits: 0, freeApplied: 0, packConflict: false, freeLines: {}, remaining: 0 };
    (cart && cart.items || []).forEach(function (item) {
      var pid = Number(item.product_id), qty = Number(item.quantity) || 0;
      var unit = Number(item.original_price != null ? item.original_price : item.price) || 0;
      if (eligibleIds.has(pid) && unit > 0) s.eligibleUnits += qty;
      if (teeIds.has(pid)) {
        s.teeUnits += qty;
        var freeAmt = 0;
        lineAllocations(item).forEach(function (a) {
          if (a.amount <= 0) return;
          if (isFreeTeeTitle(a.title)) freeAmt += a.amount; else s.packConflict = true;
        });
        var units = unit > 0 ? Math.min(qty, Math.floor((freeAmt + 0.5) / unit)) : 0;
        s.freeApplied += units;
        if (units > 0) s.freeLines[item.key] = units;
      }
    });
    s.remaining = Math.max(0, s.eligibleUnits - s.freeApplied);
    return s;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { computeState: computeState, isFreeTeeTitle: isFreeTeeTitle, lineAllocations: lineAllocations };
    if (typeof window === 'undefined') return;
  }

  /* ---------------- browser ---------------- */
  var cfgEl = document.getElementById('dr-ft-config');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var ROOT = (CFG.rootUrl || '/').replace(/\/$/, '');
  var origFetch = window.fetch.bind(window);
  /* r47: per-tab session memory + cross-tab ping (no personal data stored) */
  var SS = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem('drft:' + k)); } catch (e) { return null; } },
    set: function (k, v) { try { if (v == null) sessionStorage.removeItem('drft:' + k); else sessionStorage.setItem('drft:' + k, JSON.stringify(v)); } catch (e) {} }
  };
  function ping() { try { localStorage.setItem('drft:sync', String(Date.now()) + Math.random()); } catch (e) {} }
  /* r47 A-11: every network call the popup depends on has a hard timeout */
  var TIMEOUT = 10000;
  function tfetch(url, opts, ms) {
    opts = opts || {};
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    if (ctl) opts.signal = ctl.signal;
    var t;
    return Promise.race([
      origFetch(url, opts),
      new Promise(function (_, rej) { t = setTimeout(function () { if (ctl) try { ctl.abort(); } catch (e) {} rej(new Error('timeout')); }, ms || TIMEOUT); })
    ]).then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }

  var data = null, dataPromise = null, cart = null, state = null, lastEligible = null;
  var pendingAddIds = [];
  var selfBusy = 0, refreshTimer = null, modal = null, lastFocus = null, scrollY = 0;
  var step = 'brands', brandSel = null; /* r60: 'brands' | 'grid'; brandSel null = all tees */

  var TXT = {
    title: 'YOUR FREE T-SHIRT',
    sub: 'Your purchase unlocks a free T-shirt. Choose your favourite. Not combinable with T-shirt packs.',
    subBrands: 'Choose your brand to discover your free T-shirt. Not combinable with T-shirt packs.',
    allBrands: 'ALL T-SHIRTS',
    allShort: 'All T-shirts',
    back: '\u2190 BACK TO BRANDS',
    left: function (n) { return n === 1 ? '1 free T-shirt left' : n + ' free T-shirts left to choose'; },
    banner: function (n) { return n === 1 ? 'You have 1 free T-shirt to choose' : 'You have ' + n + ' free T-shirts to choose'; },
    included: function (n) { return n === 1 ? 'Your free T-shirt is included' : 'Your ' + n + ' free T-shirts are included'; },
    packApplied: 'T-shirt pack pricing is applied.',
    packElig: 'T-shirt pack pricing is applied. Packs are not combinable with the complimentary T-shirt \u2014 the better offer is applied automatically.',
    nc: 'Not combinable with T-shirt packs.',
    choose: 'Choose your T-shirt',
    add: 'Add free T-shirt',
    pickSize: 'Select a size',
    adding: 'Adding…',
    done: 'All set — your free T-shirts are in your cart.',
    added: 'Added — the free T-shirt discount is applied in your cart.',
    pack: 'Your T-shirt pack offer is currently applied. Free T-shirts can\u2019t be combined with T-shirt packs \u2014 the best offer is applied automatically at checkout.',
    notApplied: 'This T-shirt was added to your cart, but the free T-shirt discount isn\u2019t showing on it yet. The best available offer is applied automatically at checkout.',
    error: 'Sorry, this T-shirt couldn\u2019t be added. Please try another size.',
    empty: 'No T-shirts are available right now.',
    taken: 'Your free T-shirt has already been chosen (for example in another tab). Your cart has been updated.',
    lostTitle: 'Your T-shirt is no longer free',
    lost: function (name, price, n) { return 'The eligible piece was removed, so the free T-shirt offer no longer applies. ' + name + (n > 1 ? ' (' + n + ' pcs)' : '') + ' is now ' + price + (n > 1 ? ' each' : '') + '.'; },
    lostRemove: 'Remove T-shirt',
    lostKeep: 'Keep it',
    failTitle: 'We couldn\u2019t update this view',
    fail: 'Your cart is safe \u2014 prices and offers are always confirmed by Shopify at checkout.',
    retry: 'Try again'
  };

  function money(cents) {
    cents = Number(cents) || 0;
    var fmt = CFG.moneyFormat || '\u20ac{{amount_with_comma_separator}}';
    function d(n, prec, th, dec) {
      var v = (n / 100).toFixed(prec).split('.');
      return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (v[1] ? dec + v[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_with_comma_separator': return d(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return d(cents, 2, "'", '.');
        case 'amount_with_space_separator': return d(cents, 2, ' ', ',');
        case 'amount_no_decimals': return d(cents, 0, ',', '.');
        default: return d(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function loadCollection(handle) {
    var all = [];
    function page(n) {
      return tfetch(ROOT + '/collections/' + handle + '?view=drft-data&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) { var j = JSON.parse(t); all = all.concat(j.products || []); return (j.pages > n && n < 10) ? page(n + 1) : all; });
    }
    return page(1).catch(function () {
      /* fallback: Shopify public products.json (prices are strings in major units) */
      var out = [];
      function jp(n) {
        return tfetch(ROOT + '/collections/' + handle + '/products.json?limit=250&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.products || []).map(function (p) {
              var img = p.images && p.images[0];
              var vs = (p.variants || []).map(function (v) { return { id: v.id, title: v.title, option: v.option1, available: !!v.available, price: Math.round(parseFloat(v.price) * 100) || 0 }; });
              return { id: p.id, title: p.title, handle: p.handle, available: vs.some(function (v) { return v.available; }), image: img ? img.src : null, srcset: '', alt: p.title, variants: vs };
            });
            out = out.concat(ps);
            return (ps.length === 250 && n < 5) ? jp(n + 1) : out;
          });
      }
      return jp(1);
    });
  }
  function loadData() {
    if (!dataPromise) {
      dataPromise = Promise.all([loadCollection(CFG.teesHandle), loadCollection(CFG.eligibleHandle)]).then(function (r) {
        var ex = (CFG.excludeTitleMatch || []).map(norm);
        var teeIds = new Set(r[0].map(function (p) { return Number(p.id); }));
        var tees = r[0].filter(function (p) {
          if (!p.available) return false;
          if ((CFG.excludeHandles || []).indexOf(p.handle) !== -1) return false;
          var t = norm(p.title); if (ex.some(function (x) { return t.indexOf(x) !== -1; })) return false;
          return p.variants.some(function (v) { return v.available; });
        });
        data = { tees: tees, teeIds: teeIds, eligibleIds: new Set(r[1].map(function (p) { return Number(p.id); })) };
        return data;
      }).catch(function (e) { dataPromise = null; throw e; });
    }
    return dataPromise;
  }

  function fetchCart() {
    return tfetch(ROOT + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  /* r44: ordered refreshes — only the newest /cart.js response is applied */
  var reqSeq = 0, appliedSeq = 0, inflight = 0, pendingOpen = null, lastAddAt = 0;
  /* r45: every cart snapshot carries the sequence number of the request that produced it;
     an older snapshot never overwrites a newer one. Dawn's /cart/change|update response IS the full cart,
     so it is applied directly (no extra /cart.js). Only /cart/add (returns items, not the cart) needs one /cart.js. */
  function isCart(j) { return j && Array.isArray(j.items) && typeof j.item_count === 'number' && ('token' in j || 'total_price' in j); }
  function applyCart(c, my) {
    if (my < appliedSeq) return false;
    appliedSeq = my;
    cart = c;
    state = computeState(cart, data.eligibleIds, data.teeIds);
    lastEligible = state.eligibleUnits;
    lastError = false;
    trackLost();
    if (state.remaining <= 0) SS.set('dismissed', null);
    if (inflight === 0) { renderBanners(); setLoading(false); }
    if (reopenArmed) renderReopen();
    if (modal && !modal.hasAttribute('hidden')) renderCounter();
    maybeOpen(my);
    return true;
  }
  function refresh() {
    var my = ++reqSeq;
    return Promise.all([loadData(), fetchCart()]).then(function (r) { applyCart(r[1], my); return { state: state }; })
      .catch(function (e) { if (window.console) console.warn('[dr-free-tee]', e); fail(); });
  }
  /* r47 A-11: never leave "Updating your cart…" on screen; show a clear, recoverable message instead */
  var lastError = false, busyWatch = null;
  function fail() {
    lastError = true;
    if (inflight === 0) setLoading(false);
    renderBanners();
    if (modal && !modal.hasAttribute('hidden')) { modal.classList.remove('is-adding'); showMsg(TXT.fail, 'error'); }
  }
  /* r47 A-07: remember which tee variants were free; if that discount disappears, warn with the new price */
  function trackLost() {
    var mem = SS.get('freeVars') || {}, seen = {}, lost = [], totWas = 0;
    (cart.items || []).forEach(function (it) {
      if (!data.teeIds.has(Number(it.product_id))) return;
      var vid = String(it.variant_id), qty = Number(it.quantity) || 0;
      var freeNow = state.freeLines[it.key] || 0;
      seen[vid] = (seen[vid] || 0) + freeNow;
      var hasOther = lineAllocations(it).some(function (a) { return a.amount > 0 && !isFreeTeeTitle(a.title); });
      var was = Math.min(qty, mem[vid] || 0); totWas += was;
      if (!hasOther && was > freeNow) lost.push({ key: it.key, qty: qty, n: was - freeNow, name: it.product_title, size: it.variant_title, price: Number(it.final_price) || 0 });
    });
    /* phase25: Shopify may move the free discount to another tee; only warn when the total number of free tees actually dropped */
    if (state.freeApplied >= totWas) lost = [];
    var next = {};
    Object.keys(seen).forEach(function (v) { next[v] = Math.max(seen[v], mem[v] || 0); });
    SS.set('freeVars', Object.keys(next).length ? next : null);
    state.lost = lost;
  }
  function ackLost() {
    var mem = SS.get('freeVars') || {};
    (cart && cart.items || []).forEach(function (it) { var v = String(it.variant_id); if (mem[v] != null) mem[v] = state.freeLines[it.key] || 0; });
    SS.set('freeVars', mem);
    if (state) state.lost = [];
    renderBanners();
  }
  function removeLost() {
    var l = state && state.lost && state.lost[0]; if (!l) return;
    selfBusy++; setLoading(true);
    var secIds = sectionIds();
    tfetch(ROOT + '/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: l.key, quantity: Math.max(0, l.qty - l.n), sections: secIds.join(','), sections_url: location.pathname }) }, 15000)
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error('change'); return j; }); })
      .then(function (j) {
        var mem = SS.get('freeVars') || {}; var v = null;
        (cart.items || []).forEach(function (it) { if (it.key === l.key) v = String(it.variant_id); });
        if (v && mem[v] != null) { mem[v] = Math.max(0, mem[v] - l.n); SS.set('freeVars', mem); }
        selfBusy = Math.max(0, selfBusy - 1);
        ping();
        if (isCart(j)) applyCart(j, ++reqSeq);
        setLoading(false);
        syncThemeCart(j.sections);
      })
      .catch(function () { selfBusy = Math.max(0, selfBusy - 1); fail(); });
  }
  /* queued auto-open: consumed once per add, only on a cart snapshot taken after that add */
  var autoOpenedFor = -1, reopenArmed = false, addedOpen = false;
  /* r66 M2: hold the auto-open until the cookie banner is resolved (html.dr-pc-open is set while it is visible); max ~5 min */
  function openWhenConsentResolved() {
    var n = 0;
    (function tick() {
      if (document.documentElement.classList.contains('dr-pc-open') && n++ < 600) { setTimeout(tick, 500); return; }
      setTimeout(openModal, 150);
    })();
  }
  function maybeOpen(my) {
    if (!pendingOpen || inflight > 0 || my < pendingOpen.seq) return;
    var po = pendingOpen;
    var eligibleAdd = po.ids.some(function (id) { return data.eligibleIds.has(id); }) ||
      (po.baseline !== null && state.eligibleUnits > po.baseline) || (!po.ids.length && po.baseline === null && state.eligibleUnits > 0);
    pendingOpen = null;
    /* never auto-open when everything is claimed / pack applies; once per eligible-unit level */
    if (!eligibleAdd || state.remaining <= 0 || state.packConflict || selfBusy) return;
    if (state.eligibleUnits <= autoOpenedFor) return;
    autoOpenedFor = state.eligibleUnits; SS.set('opened', autoOpenedFor);
    addedOpen = true; /* r66 M1 */
    openWhenConsentResolved(); /* r66 M2 */
  }
  function queueOpen(ids, seq) {
    if (!pendingOpen) pendingOpen = { ids: [], baseline: state ? state.eligibleUnits : null, seq: seq };
    (ids || []).forEach(function (id) { if (id) pendingOpen.ids.push(Number(id)); });
    pendingOpen.seq = Math.max(pendingOpen.seq, seq);
  }

  /* ---- triggers: fetch interception (primary) + Dawn PUB_SUB (only if the fetch hook missed it) ---- */
  var lastHookedAt = 0;
  function hookPubSub() {
    var EV = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS) || window.PUB_SUB_EVENTS;
    var sub = (typeof subscribe === 'function' && subscribe) || window.subscribe;
    if (typeof sub === 'function' && EV && EV.cartUpdate) {
      sub(EV.cartUpdate, function (ev) {
        if (selfBusy || Date.now() - lastHookedAt < 4000) return; /* already handled from the fetch response */
        var src = ev && ev.source;
        if (src && src !== 'cart-items') { var cd = ev.cartData || {}; queueOpen((cd.items || [cd]).map(function (i) { return i && i.product_id; }), reqSeq + 1); }
        refresh();
      });
      return true;
    }
    return false;
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var watched = !selfBusy && method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url).split('#')[0]);
    if (!watched) return origFetch(input, init);
    var my = ++reqSeq, isAdd = /\/cart\/add/.test(url);
    inflight++; setLoading(true); lastHookedAt = Date.now();
    var p = origFetch(input, init);
    var finish = function () { inflight = Math.max(0, inflight - 1); if (inflight === 0) { renderBanners(); setLoading(false); } };
    p.then(function (res) {
      if (!res || !res.ok) { finish(); return; }
      res.clone().json().catch(function () { return null; }).then(function (j) {
        if (isAdd) {
          var items = (j && j.items) ? j.items : (j && j.product_id ? [j] : []);
          queueOpen(items.map(function (it) { return it && it.product_id; }), my + 1);
          inflight = Math.max(0, inflight - 1);
          ping();
          refresh(); /* one /cart.js, immediately */
          return;
        }
        if (isCart(j)) {
          ping();
          return loadData().then(function () { inflight = Math.max(0, inflight - 1); applyCart(j, my); if (inflight === 0) setLoading(false); },
            function () { inflight = Math.max(0, inflight - 1); fail(); });
        }
        inflight = Math.max(0, inflight - 1); refresh();
      }).catch(finish);
    }, finish);
    return p;
  };
  /* immediate loading state: banners keep their box but show "Updating…" (no stale confirmation) */
  function setLoading(on) {
    document.documentElement.classList.toggle('dr-ft-busy', !!on);
    clearTimeout(busyWatch);
    if (on) busyWatch = setTimeout(function () { if (document.documentElement.classList.contains('dr-ft-busy')) { inflight = 0; fail(); } }, 15000);
    document.querySelectorAll('.dr-ft-slot').forEach(function (el) {
      if (on) { el.setAttribute('aria-busy', 'true'); el.innerHTML = '<div class="dr-ft-banner dr-ft-banner--note dr-ft-banner--loading"><span class="dr-ft-spin" aria-hidden="true"></span><p class="dr-ft-banner__text">Updating your cart\u2026</p></div>'; }
      else el.removeAttribute('aria-busy');
    });
    if (modal) modal.classList.toggle('is-busy', !!on);
  }

  /* ---- cart reminder banners ---- */
  function bannerHTML() {
    if (lastError && inflight === 0) return '<div class="dr-ft-banner dr-ft-banner--note dr-ft-banner--error" role="alert"><p class="dr-ft-banner__title">' + esc(TXT.failTitle) + '</p><p class="dr-ft-banner__text">' + esc(TXT.fail) + '</p><button type="button" class="dr-ft-banner__btn" data-dr-ft-retry>' + esc(TXT.retry) + '</button></div>';
    if (!state || !data) return '';
    if (inflight > 0) return (state.eligibleUnits > 0 || state.teeUnits > 0) ? '<div class="dr-ft-banner dr-ft-banner--note dr-ft-banner--loading" aria-busy="true"><span class="dr-ft-spin" aria-hidden="true"></span><p class="dr-ft-banner__text">Updating your cart\u2026</p></div>' : '';
    var note = function (t) { return '<div class="dr-ft-banner dr-ft-banner--note" role="note"><p class="dr-ft-banner__text">' + esc(t) + '</p></div>'; };
    var lostHTML = '';
    if (state.lost && state.lost.length) {
      var l = state.lost[0], nm = l.name + (l.size ? ' \u00b7 ' + sizeLabel(l.size) : '');
      lostHTML = '<div class="dr-ft-banner dr-ft-banner--warn" role="alert"><p class="dr-ft-banner__title">' + esc(TXT.lostTitle) + '</p><p class="dr-ft-banner__text">' + esc(TXT.lost(nm, money(l.price), l.n)) + '</p>' +
        '<div class="dr-ft-banner__actions"><button type="button" class="dr-ft-banner__btn" data-dr-ft-remove>' + esc(TXT.lostRemove) + '</button><button type="button" class="dr-ft-banner__link" data-dr-ft-keep>' + esc(TXT.lostKeep) + '</button></div></div>';
      return lostHTML; /* a still-claimable gift would already be applied by Shopify to this tee */
    }
    if (state.packConflict) {
      if (state.freeApplied > 0) return note(TXT.included(state.freeApplied) + ' \u00b7 ' + TXT.packElig);
      return note(state.eligibleUnits > 0 ? TXT.packElig : TXT.packApplied);
    }
    if (state.remaining > 0 && data.tees.length) return '<div class="dr-ft-banner" role="note"><p class="dr-ft-banner__title">' + esc(TXT.banner(state.remaining)) + '</p><p class="dr-ft-banner__text dr-ft-banner__nc">' + esc(TXT.nc) + '</p><button type="button" class="dr-ft-banner__btn" data-dr-ft-open>' + esc(TXT.choose) + '</button></div>';
    if (state.freeApplied > 0) return '<div class="dr-ft-banner dr-ft-banner--note dr-ft-banner--ok" role="status"><p class="dr-ft-banner__title">' + esc(TXT.included(state.freeApplied)) + '</p></div>';
    return '';
  }
  function renderBanners() {
    var html = bannerHTML();
    document.documentElement.classList.toggle('dr-ft-ready', true);
    var targets = [
      document.querySelector('#main-cart-items .js-contents'),
      document.querySelector('cart-drawer .drawer__inner .cart-drawer__form') || document.querySelector('cart-drawer #CartDrawer-CartItems'),
      document.querySelector('#cart-notification .cart-notification__links')
    ];
    targets.forEach(function (t) {
      if (!t) return;
      var old = t.parentNode && t.parentNode.querySelector(':scope > .dr-ft-slot');
      if (t.id === 'cart-notification' || t.classList.contains('cart-notification__links')) old = t.parentNode.querySelector('.dr-ft-slot');
      else old = t.querySelector(':scope > .dr-ft-slot');
      if (!html) { if (old) old.remove(); return; }
      if (!old) { old = document.createElement('div'); old.className = 'dr-ft-slot'; if (t.classList.contains('cart-notification__links')) t.parentNode.insertBefore(old, t); else t.insertBefore(old, t.firstChild); }
      old.innerHTML = html; old.style.visibility = '';
    });
  }
  /* cart page / drawer contents are re-rendered by Dawn: re-insert banner when replaced */
  var mo = new MutationObserver(function () {
    if (!state) return;
    var need = !!bannerHTML();
    var c = document.querySelector('#main-cart-items .js-contents');
    var n = document.querySelector('#cart-notification .cart-notification__links');
    if (need && ((c && !c.querySelector(':scope > .dr-ft-slot')) || (n && !n.parentNode.querySelector('.dr-ft-slot')))) renderBanners();
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dr-ft-open]');
    if (b) { e.preventDefault(); openModal(); return; }
    if (e.target.closest && e.target.closest('[data-dr-ft-remove]')) { e.preventDefault(); removeLost(); return; }
    if (e.target.closest && e.target.closest('[data-dr-ft-keep]')) { e.preventDefault(); ackLost(); return; }
    if (e.target.closest && e.target.closest('[data-dr-ft-retry]')) { e.preventDefault(); lastError = false; setLoading(true); refresh().then(function () { var onCart = CFG.pageType === 'cart' || /\/cart\/?$/.test(location.pathname); if (!lastError && onCart) syncThemeCart(); }); }
  });

  /* ---- modal ---- */
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'dr-ft';
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="dr-ft__backdrop" data-dr-ft-close></div>' +
      '<div class="dr-ft__panel" role="dialog" aria-modal="true" aria-labelledby="dr-ft-title" aria-describedby="dr-ft-sub" tabindex="-1">' +
        '<div class="dr-ft__head">' +
          '<span class="dr-ft__grab" aria-hidden="true"></span>' +
          '<button type="button" class="dr-ft__back" data-dr-ft-back hidden>' + esc(TXT.back) + '</button>' +
          '<button type="button" class="dr-ft__close" data-dr-ft-close aria-label="Close">\u00d7</button>' +
          '<p class="dr-ft__added" role="status" hidden>Added to cart</p>' +
          '<h2 class="dr-ft__title" id="dr-ft-title">' + esc(TXT.title) + '</h2>' +
          '<p class="dr-ft__sub" id="dr-ft-sub">' + esc(TXT.sub) + '</p>' +
          '<p class="dr-ft__pill" aria-live="polite"></p>' +
          '<p class="dr-ft__msg" role="status" aria-live="polite" hidden></p>' +
        '</div>' +
        '<div class="dr-ft__body"><div class="dr-ft__brands" role="group" aria-label="Brands"></div><ul class="dr-ft__grid" role="list" hidden></ul></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.dr-ft__close').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeModal(); });
    var downOutside = false;
    var outside = function (e) { var pnl = modal.querySelector('.dr-ft__panel'); return !(pnl && pnl.contains(e.target)); };
    modal.addEventListener('pointerdown', function (e) { downOutside = outside(e); }, true);
    modal.addEventListener('click', function (e) { if (outside(e) && downOutside !== false) { e.preventDefault(); e.stopPropagation(); downOutside = false; closeModal(); } }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-dr-ft-close]')) { closeModal(); return; }
      var bb = e.target.closest('.dr-ft__brand');
      if (bb) { if (!bb.disabled && !selfBusy) showStep('grid', bb.dataset.brand || null, 'back'); return; }
      if (e.target.closest('[data-dr-ft-back]')) { if (!selfBusy) { var prev = brandSel; showStep('brands', prev, 'brand'); } return; }
      var chip = e.target.closest('.dr-ft__chip');
      if (chip && !chip.disabled) {
        var card = chip.closest('.dr-ft__card');
        modal.querySelectorAll('.dr-ft__card').forEach(function (oc) {
          if (oc === card || !oc.dataset.variant) return;
          delete oc.dataset.variant;
          oc.querySelectorAll('.dr-ft__chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          var ob = oc.querySelector('.dr-ft__add'); if (ob && !ob.classList.contains('is-busy')) { ob.disabled = true; ob.textContent = TXT.pickSize; }
        });
        card.querySelectorAll('.dr-ft__chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        card.dataset.variant = chip.dataset.variant;
        var btn = card.querySelector('.dr-ft__add'); btn.disabled = !(state && state.remaining > 0 && !state.packConflict && !selfBusy); if (!btn.classList.contains('is-busy')) btn.textContent = TXT.add;
        return;
      }
      var add = e.target.closest('.dr-ft__add');
      if (add && !add.disabled) addTee(add.closest('.dr-ft__card'), add);
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(modal.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === modal.querySelector('.dr-ft__panel'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* display only: 'XS / 1' -> 'XS'; variant id is untouched */
  function sizeLabel(t) {
    t = String(t == null ? '' : t).trim();
    var parts = t.split(/\s*\/\s*/);
    if (parts.length > 1) { var letter = parts.filter(function (x) { return /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL|OS|ONE SIZE)$/i.test(x); })[0]; return letter || parts[0]; }
    return t;
  }
  /* r60: brands come from the same data as the tees (product metafield custom.brand = the T-shirts collection filter); nothing hard-coded */
  function brandKey(p) { return String(p && p.brand || '').trim(); }
  function brandList() {
    var m = Object.create(null), names = [];
    data.tees.forEach(function (p) { var b = brandKey(p); if (!b) return; if (!(b in m)) { m[b] = 0; names.push(b); } m[b]++; });
    names.sort(function (a, b) { return a.localeCompare(b, undefined, { sensitivity: 'base' }); });
    return names.map(function (n) { return { name: n, count: m[n] }; });
  }
  function brandBtn(name, count, all) {
    return '<button type="button" class="dr-ft__brand' + (all ? ' is-all' : '') + '" data-brand="' + esc(name) + '" aria-label="' + esc((all ? TXT.allBrands : name) + ', ' + count + ' T-shirts') + '"><span class="dr-ft__bname">' + esc(all ? TXT.allBrands : name) + '</span><span class="dr-ft__bcount" aria-hidden="true">' + count + '</span></button>';
  }
  function renderBrands() {
    modal.querySelector('.dr-ft__brands').innerHTML = brandBtn('', data.tees.length, true) + brandList().map(function (b) { return brandBtn(b.name, b.count, false); }).join('');
  }
  /* r60: step 1 (brands, no images) <-> step 2 (existing card grid, filtered). No brand data -> straight to the grid (previous behaviour). */
  function showStep(s, brand, focus) {
    var hasBrands = brandList().length > 0;
    if (!hasBrands) s = 'grid';
    step = s; brandSel = s === 'grid' ? (brand || null) : null;
    var br = modal.querySelector('.dr-ft__brands'), grid = modal.querySelector('.dr-ft__grid'), back = modal.querySelector('.dr-ft__back'), sub = modal.querySelector('.dr-ft__sub');
    var onBrands = s === 'brands';
    if (onBrands) { grid.innerHTML = ''; renderBrands(); sub.textContent = TXT.subBrands; }
    else { renderGrid(); sub.textContent = hasBrands ? (brandSel || TXT.allShort) : TXT.sub; }
    sub.classList.toggle('is-brand', !onBrands && hasBrands);
    br.hidden = !onBrands; grid.hidden = onBrands; back.hidden = onBrands || !hasBrands;
    var el = onBrands ? br : grid; el.classList.remove('is-enter'); void el.offsetWidth; el.classList.add('is-enter');
    modal.querySelector('.dr-ft__body').scrollTop = 0;
    renderCounter();
    if (focus === 'back') back.focus({ preventScroll: true });
    else if (focus === 'brand') { var t = Array.prototype.filter.call(br.querySelectorAll('.dr-ft__brand'), function (b) { return (b.dataset.brand || null) === brand; })[0] || br.querySelector('.dr-ft__brand'); if (t) t.focus({ preventScroll: true }); }
  }
  function renderGrid() {
    var grid = modal.querySelector('.dr-ft__grid');
    var list = brandSel ? data.tees.filter(function (p) { return brandKey(p) === brandSel; }) : data.tees;
    if (!list.length) { grid.innerHTML = '<li class="dr-ft__empty">' + esc(TXT.empty) + '</li>'; return; }
    grid.innerHTML = list.map(function (p) {
      var chips = p.variants.map(function (v) {
        var label = sizeLabel(v.option || v.title);
        return '<button type="button" class="dr-ft__chip" data-variant="' + v.id + '" aria-pressed="false"' + (v.available ? '' : ' disabled aria-disabled="true" title="Sold out"') + '>' + esc(label) + '</button>';
      }).join('');
      var price = p.variants[0] ? p.variants[0].price : 0;
      return '<li class="dr-ft__card" data-product="' + p.id + '">' +
        '<div class="dr-ft__media">' + (p.image ? '<img src="' + esc(p.image) + '" srcset="' + esc(p.srcset || '') + '" sizes="(min-width: 990px) 230px, (min-width: 750px) 30vw, 46vw" alt="' + esc(p.alt) + '" loading="lazy" decoding="async" width="600" height="750">' : '') + '</div>' +
        '<p class="dr-ft__name">' + esc(p.title) + '</p>' +
        '<p class="dr-ft__price">' + esc(money(price)) + '</p>' +
        '<div class="dr-ft__chips" role="group" aria-label="Size">' + chips + '</div>' +
        '<button type="button" class="dr-ft__add" disabled>' + esc(TXT.pickSize) + '</button>' +
      '</li>';
    }).join('');
  }

  /* lastAdd: result of the last popup add; message is always re-derived from the CURRENT state together with the pill */
  var lastAdd = null;
  function renderCounter() {
    if (!modal || !state) return;
    var pill = modal.querySelector('.dr-ft__pill');
    var msg = '', kind = '';
    if (state.packConflict && state.freeApplied === 0) { msg = TXT.packElig; kind = 'note'; }
    else if (lastAdd === 'error') { msg = TXT.error; kind = 'error'; }
    else if (lastAdd === 'taken') { msg = TXT.taken; kind = 'note'; }
    else if (lastAdd) {
      if (state.freeApplied > lastAdd.before) {
        if (state.remaining === 0) { msg = TXT.done; kind = 'ok'; } else { msg = TXT.added; kind = 'ok'; }
      } else { msg = TXT.notApplied; kind = 'note'; }
    } else if (state.remaining === 0 && state.freeApplied > 0 && !state.packConflict) { msg = TXT.done; kind = 'ok'; }
    if (state.remaining > 0 && !(state.packConflict && state.freeApplied === 0)) {
      pill.hidden = false;
      pill.innerHTML = '<span class="dr-ft__num">' + state.remaining + '</span> ' + esc(state.remaining === 1 ? 'free T-shirt left' : 'free T-shirts left to choose');
    } else pill.hidden = true;
    showMsg(msg, kind);
    var canAdd = state.remaining > 0 && !state.packConflict && !selfBusy;
    var navDone = state.remaining <= 0 || (state.packConflict && state.freeApplied === 0);
    modal.querySelectorAll('.dr-ft__brand').forEach(function (b) { b.disabled = navDone; });
    modal.querySelectorAll('.dr-ft__card').forEach(function (c) {
      var bt = c.querySelector('.dr-ft__add');
      if (!bt.classList.contains('is-busy')) bt.disabled = !(canAdd && c.dataset.variant);
    });
  }
  function showMsg(text, kind) {
    var m = modal.querySelector('.dr-ft__msg');
    m.hidden = !text; m.textContent = text || ''; m.dataset.kind = kind || '';
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-scrollY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
    document.documentElement.classList.add('dr-ft-locked');
  }
  function unlockScroll() {
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
    document.documentElement.classList.remove('dr-ft-locked');
    window.scrollTo(0, scrollY);
  }

  var addedThisSession = false;
  var opening = false;
  function openModal() {
    if (opening || (modal && modal.classList.contains('is-open'))) return;
    opening = true;
    loadData().then(function () {
      opening = false;
      if (modal && modal.classList.contains('is-open')) return;
      if (!modal) buildModal();
      lastAdd = null; showMsg(''); showStep('brands', null, null);
      var ad = modal.querySelector('.dr-ft__added'); if (ad) { ad.hidden = !addedOpen; } addedOpen = false; /* r66 M1 */
      /* close Dawn's cart notification so only one dialog is visible */
      var n = document.querySelector('cart-notification'); if (n && typeof n.close === 'function' && n.querySelector('.active, [class*="active"]')) { try { n.close(); } catch (e) {} }
      var ro = document.getElementById('dr-ft-reopen'); if (ro) ro.hidden = true;
      lastFocus = document.activeElement;
      lockScroll();
      modal.removeAttribute('hidden');
      requestAnimationFrame(function () { requestAnimationFrame(function () { modal.classList.add('is-open'); }); });
      setTimeout(function () { var c = modal.querySelector('.dr-ft__close'); c && c.focus(); }, 30);
      document.dispatchEvent(new CustomEvent('dr-free-tee:open'));
    });
  }
  function closeModal() {
    if (!modal || modal.hasAttribute('hidden') || modal.dataset.closing) return;
    modal.dataset.closing = '1';
    pendingOpen = null;
    modal.classList.remove('is-open');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () {
      modal.setAttribute('hidden', '');
      delete modal.dataset.closing;
      unlockScroll();
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      addedThisSession = false;
      reopenArmed = true; if (state && state.remaining > 0) SS.set('dismissed', 1); renderReopen();
    }, reduce ? 0 : 340);
  }

  /* After our own add: refresh Dawn's cart UI (cart page reload, header bubble otherwise). */
  function sectionIds() {
    var ids = [];
    var mi = document.getElementById('main-cart-items'), mf = document.getElementById('main-cart-footer');
    if (mi && mi.dataset.id) ids.push(mi.dataset.id);
    if (mf && mf.dataset.id) ids.push(mf.dataset.id);
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }
  function syncThemeCart(pre) {
    var ids = sectionIds();
    var mi = document.getElementById('main-cart-items'), mf = document.getElementById('main-cart-footer');
    var onCart = CFG.pageType === 'cart' || /\/cart\/?$/.test(location.pathname);
    if (!ids.length) { if (onCart) location.reload(); return; }
    var got = pre && ids.every(function (id) { return pre[id]; }) ? Promise.resolve(pre) :
    origFetch(location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); });
    got.then(function (j) {
        function swap(id, el, sel) {
          if (!el || !j[id]) return false;
          var doc = new DOMParser().parseFromString(j[id], 'text/html');
          var src = sel ? doc.querySelector(sel) : (doc.querySelector('.shopify-section') || doc.body);
          var dst = sel ? el.querySelector(sel) || el : el;
          if (!src) return false;
          dst.innerHTML = src.innerHTML; return true;
        }
        var ok = true;
        if (mi) ok = swap(mi.dataset.id, mi, '.js-contents') && ok;
        if (mf) ok = swap(mf.dataset.id, mf, '.js-contents') && ok;
        swap('cart-icon-bubble', document.getElementById('cart-icon-bubble'), null);
        if (mi && cart) {
          var cartEl = document.querySelector('cart-items'); if (cartEl) cartEl.classList.toggle('is-empty', cart.item_count === 0);
          var form = document.getElementById('main-cart-footer'); if (form) form.classList.toggle('is-empty', cart.item_count === 0);
        }
        renderBanners();
        if (!ok && onCart) location.reload();
      })
      .catch(function () { if (onCart) location.reload(); });
  }

  function addTee(card, btn) {
    var vid = Number(card.dataset.variant); if (!vid || selfBusy || !state || state.remaining <= 0 || state.packConflict) return;
    selfBusy++;
    modal.classList.add('is-adding');
    modal.querySelectorAll('.dr-ft__add').forEach(function (b) { b.disabled = true; });
    btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); btn.innerHTML = '<span class="dr-ft-spin" aria-hidden="true"></span>' + esc(TXT.adding); showMsg('');
    var secIds = sectionIds(), before = 0;
    /* r47 A-08: revalidate the real cart + quota right before adding (another tab may have used it) */
    var seq0 = ++reqSeq;
    fetchCart().then(function (c) {
      applyCart(c, seq0);
      before = state.freeApplied;
      if (state.remaining <= 0 || state.packConflict) { var e = new Error('taken'); e.taken = true; throw e; }
      return tfetch(ROOT + '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      /* Shopify Section Rendering in the same request: no extra section fetch afterwards */
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: secIds.join(','), sections_url: location.pathname })
    }, 15000); }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'add failed'); return j; }); })
      .then(function (j) { addedThisSession = true; ping(); var sec = j && j.sections; return refresh().then(function () { syncThemeCart(sec); }); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.textContent = TXT.add; modal.classList.remove('is-adding');
        lastAdd = { before: before };
        /* clear the selection so the next free tee is a fresh, single choice */
        delete card.dataset.variant;
        card.querySelectorAll('.dr-ft__chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        btn.textContent = TXT.pickSize;
        selfBusy = Math.max(0, selfBusy - 1); renderCounter(); selfBusy++;
        if (state.freeApplied > before && state.remaining === 0 && !state.packConflict) {
          setTimeout(function () { if (state && state.remaining === 0) closeModal(); }, 1800);
        }
      })
      .catch(function (e) {
        btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.textContent = TXT.add; modal.classList.remove('is-adding');
        lastAdd = e && e.taken ? 'taken' : 'error';
        if (e && e.taken) { var onCart = CFG.pageType === 'cart' || /\/cart\/?$/.test(location.pathname); if (onCart) syncThemeCart(); }
      })
      .then(function () { selfBusy = Math.max(0, selfBusy - 1); renderCounter(); });
  }

  /* small persistent re-entry point after closing without choosing (not on /cart, where the banner is) */
  function renderReopen() {
    var el = document.getElementById('dr-ft-reopen');
    var onCart = CFG.pageType === 'cart' || /\/cart\/?$/.test(location.pathname);
    var show = state && state.remaining > 0 && !state.packConflict && !onCart && data && data.tees.length && (!modal || modal.hasAttribute('hidden')) && inflight === 0;
    if (!show) { if (el) el.hidden = true; return; }
    if (!el) { el = document.createElement('button'); el.type = 'button'; el.id = 'dr-ft-reopen'; el.className = 'dr-ft-reopen'; el.setAttribute('data-dr-ft-open', ''); document.body.appendChild(el); }
    el.innerHTML = '<span class="dr-ft__num">' + state.remaining + '</span> ' + esc(state.remaining === 1 ? 'Choose your free T-shirt' : 'Choose your free T-shirts');
    el.hidden = false;
    tuck();
  }
  /* r47 A-09: the reopen pill steps aside whenever it would cover a buy / checkout control */
  var CRIT = '.product-form__buttons, [name="add"], .shopify-payment-button, #checkout, .cart__ctas, .cart-notification__links, .quick-add-modal[open] .product-form__buttons, .cart-drawer .cart__ctas, footer .newsletter-form';
  var tuckRaf = 0;
  function tuck() {
    var el = document.getElementById('dr-ft-reopen'); if (!el || el.hidden) return;
    var r = el.getBoundingClientRect(), pad = 12, over = false;
    document.querySelectorAll(CRIT).forEach(function (c) {
      if (over || !c.offsetParent) return;
      var b = c.getBoundingClientRect();
      if (b.bottom > r.top - pad && b.top < r.bottom + pad && b.right > r.left - pad && b.left < r.right + pad) over = true;
    });
    el.classList.toggle('is-tucked', over);
  }
  ['scroll', 'resize'].forEach(function (ev) { window.addEventListener(ev, function () { if (tuckRaf) return; tuckRaf = requestAnimationFrame(function () { tuckRaf = 0; tuck(); }); }, { passive: true }); });

  /* informational note under the buy buttons on eligible, available product pages (no behaviour change) */
  function initProductNote() {
    if (!CFG.productEligible && !CFG.productTee) return; /* r68: tee note */
    var wrap = document.querySelector('main .product-form__buttons') || document.querySelector('.product-form__buttons');
    if (!wrap || document.getElementById('dr-ft-pdp-note')) return;
    var note = document.createElement('p');
    note.id = 'dr-ft-pdp-note'; note.className = 'dr-ft-pdp-note';
    note.innerHTML = CFG.productEligible
      ? '<em>Free T-shirt included</em> \u2014 add to cart to choose yours. <span class="dr-ft-pdp-note__nc">Not combinable with T-shirt packs.</span>'
      : '<span class="dr-ft-pdp-note__nc">Pack offers (3 for \u20ac150 / 5 for \u20ac200) cannot be combined with the complimentary T-shirt offer \u2014 the better offer is applied automatically.</span>';
    wrap.parentNode.insertBefore(note, wrap.nextSibling);
    var btn = wrap.querySelector('[name="add"]');
    var sync = function () { if (btn) note.hidden = btn.disabled && !btn.classList.contains('loading') && btn.getAttribute('aria-disabled') !== 'true'; };
    if (btn) { sync(); new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] }); }
  }

  window.DRFreeTee = { open: openModal, close: closeModal, refresh: refresh, state: function () { return state; } };

  function init() {
    if (SS.get('dismissed')) reopenArmed = true;
    var op = SS.get('opened'); if (typeof op === 'number') autoOpenedFor = op;
    /* r47 A-08: another tab changed the cart -> resync; tab becomes visible / restored from bfcache -> resync */
    var onCartPage = function () { return CFG.pageType === 'cart' || /\/cart\/?$/.test(location.pathname); };
    window.addEventListener('storage', function (e) { if (e.key === 'drft:sync' && !selfBusy) refresh().then(function () { if (onCartPage() && !lastError) syncThemeCart(); }); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && !selfBusy && inflight === 0) refresh(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    hookPubSub() || setTimeout(hookPubSub, 1500);
    var c = document.getElementById('main-cart-items'); if (c) mo.observe(c, { childList: true, subtree: true });
    var n = document.getElementById('cart-notification'); if (n) mo.observe(n, { childList: true, subtree: true });
    refresh();
    try { initProductNote(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
